import React, { Component } from "react";
import { Form, Layout, Button, Row, Col, Popconfirm, Table, Tag } from "antd";
import "./index.scss";
import { checkPermission } from "../../utils/helper";
import { Redirect } from "react-router-dom";

const { Content } = Layout;

class User extends Component {
  initialState = {
    auditLogsData: [],
    showCreateUpdateModal: false,
    selectedRow: {}
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  handleCloseModal = () => {
    this.setState({
      showCreateUpdateModal: false,
    });
  };

  componentDidMount() {
    const onGetParam = {
      event_id: this.props.event.id
    };
    this.props.onGetAuditLogs(onGetParam);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.auditLogsData !== nextProps.auditLogsData) {
      this.setState({ auditLogsData: nextProps.auditLogsData });
    }
  }

  render() {
    const { auditLogsData, showCreateUpdateModal, selectedRow } = this.state;
    const { isLoading, } = this.props;
    const module = "audit-log";

    if (!checkPermission(module, "view")) {
      return (<Redirect to="/403" />);
    }

    const columns = [
      {
        title: 'Username',
        dataIndex: 'user_name',
        key: 'user_name',
        render: (column, row) => (
          <span>{`${row.user ? row.user.username : ''}`}</span>
        )
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (column, row) => (
          <span>{`${row.user ? row.user.first_name : ''} ${row.user ? row.user.last_name : ''}`}</span>
        )
      },
      {
        title: 'Activity',
        dataIndex: 'activity',
        key: 'activity'
      },
      {
        title: 'Timestamp',
        dataIndex: 'created_at',
        key: 'created_at'
      }
    ];

    return (
      <Layout className="audit-log-container">
        <Content className="audit-log-content" style={{ padding: "20px 60px" }}>
          <Row type="flex" gutter={30}>
            <Col span={24}>
              <h2>Audit Log</h2>
            </Col>
          </Row>

          <Row type="flex" gutter={30}>
            <Col span={12} className="page-content-control-button-holder">
              {/* <Button type="primary" loading={isLoading} onClick={this.handleCreateButton}>Add User</Button> */}
            </Col>
          </Row>

          <Row type="flex" gutter={30}>
            <Col span={24}>
              <Table columns={columns} dataSource={auditLogsData} loading={isLoading} rowKey={"id"} />
            </Col>
          </Row>
        </Content>

        {/* <CreateUpdateModal showModal={showCreateUpdateModal} selectedRow={selectedRow} handleCloseModal={this.handleCloseModal} {...this.props} /> */}
      </Layout>
    );
  }
}

const UserForm = Form.create({ name: "audit-log-form" })(User);

export default UserForm;
